<template>
	<div class="classification">
		<div style="position: relative;height:36px;">
			<el-button type="primary" plain class="addButtonClass" @click="backClick()">返回</el-button>
			<el-button type="primary" plain class="rightButtonClass" @click="addClick()">新增分类</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%;" v-loading="loading">
				<el-table-column prop="name" label="分类名称" min-width="1%">
				</el-table-column>
				<el-table-column prop="show_type" label="前端显示方式" min-width="1%">
					<template slot-scope="scope">{{scope.row.show_type|show_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
			</el-pagination>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="分类名称" label-width="25%">
					<el-input type="text" v-model="name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="前端显示方式" label-width="25%">
					<el-select v-model="show_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in show_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.getList(); //获取列表
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "30%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "30%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		filters: {
			show_typeFilter: function(val) {
				if(val == "1") {
					return "电表";
				}
				if(val == "2") {
					return "水表";
				}
				if(val == "3") {
					return "变压器";
				}
				if(val == "4") {
					return "燃气";
				}
			}
		},
		data() {
			return {
				loading:false,//加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				dialogFormVisible: false,
				title: '', //弹窗标题
				/*表单*/
				name: '', //名称
				show_type: '', //类型
				dialogWidth: '30%', //dialog的宽度
				editId: null, //编辑的id
				show_typeList: [{
					id: 1,
					name: '电表'
				}, {
					id: 2,
					name: '水表'
				}, {
					id: 3,
					name: '变压器'
				}, {
					id: 4,
					name: '燃气'
				}],

			}
		},
		methods: {
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					 this.loading=false;
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新建分类
			addClick() {
				this.title = "新建分类"
				this.dialogFormVisible = true
				this.emptyList();
			},
			//编辑的点击
			editClick(id, list) {
				//console.log(list)
				this.dialogFormVisible = true
				this.title = '编辑分类'
				this.editId = id;
				this.name = list.name
				this.show_type = list.show_type
			},
			//保存
			save() {
				/*创建时间的处理*/
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						name: this.name,
						show_type: this.show_type,
						manager_id: manager_id,
						status: 1,
					}
				} else {
					var params = { //添加
						name: this.name,
						show_type: this.show_type,
						manager_id: manager_id,
						create_time: timestamp,
						status: 1,
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				//console.log(params)
				if(this.name && this.show_type) {
					axios.post(this.http + '/zkep2/category/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getList()
							this.emptyList()
						} else {
							if(this.editId) {
								this.$message('编辑失败！');
							} else {
								this.$message('新增失败！');
							}
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！');
				}
			},
			//清空
			emptyList() {
				this.name = ''
				this.show_type = ''
				this.editId = ''
			},
			//删除
			deleteClick(id) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/category/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//返回
			backClick() {
				this.$router.push({
					path: '/product/product',
					name: 'Product'
				})
			}
		}
	}
</script>

<style>
	.classification {
		height: 100%;
		padding: 3.2% 27% 0 27%;
		position: relative;
	}
	
	.classification .el-table th {
		color: #000;
	}
	
	.classification .el-table {
		font-size: 12px;
	}
	
	.classification .el-table th,
	.classification .el-table td,
	.classification .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.classification .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.classification .addButtonClass {
		position: absolute;
		top: 0%;
		left: 0;
		padding: 10px 28px;
		font-size: 13px;
	}
	
	.classification .rightButtonClass {
		position: absolute;
		top: 0%;
		right: 0;
		padding: 10px 15px;
		font-size: 13px;
	}
	
	.classification .tableBox {
		position: relative;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.classification .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.classification .el-dialog__title {
		color: #999;
	}
	
	.classification .el-dialog__footer {
		text-align: center;
	}
	
	.classification .pagination {
		text-align: center;
	}
	
	.classification .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Product/Classification.vue